<template>
  <div class="Empty">
    <img
      :src="require('./empty.png')"
      alt
    />
    <p>{{TLang('抱歉商品过期不存在','list')}}</p>
    <div class="empty-bottom_btn">
      <span
        v-if="showPre"
        class="pre"
        @click="toPre"
      >{{TLang('上一页','list')}}</span><span
        @click="toHome"
      >{{TLang('逛逛首页','list')}}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getQueryString, unionFlag } from '@utils';
import { fetchFindByUnion } from '@fetch';
import Cookies from 'js-cookie';
export default {
  name: 'Empty',
  data(){
    return {
      showPre:false,
      unionFlag: unionFlag(),
      union: getQueryString('union') || '',
      city: getQueryString('city') || (Cookies.get('address') && JSON.parse(Cookies.get('address') || '{}').cityId) || '145',
      channel: getQueryString('channelId') || '',
    };
  },
  computed: {
    ...mapGetters('shopCart', ['exts', 'healthgoodsFlag']),
  },
  created() {
    // 新选项卡打开的页面，不展示返回上一页
    let length = window.history.length;
    if(length > 1){
      this.showPre = true;
    }else{
      this.showPre = false;
    }
  },
  methods: {
    toPre(){
      if(window.history.length > 1){
        window.history.back();
      }else{
        window.close();
      }
    },
    toHome(){
      let hostName = window.location.hostname;
      let newFlag = hostName.indexOf('corp') != -1;
      let bfdUrl = newFlag?'/home-pc/home':'/bfd_pc/index';
      // let url = this.unionFlag ?'/shop/home?mc=Shopping' : '/shop/home';
      // if (this.channel) {
      //   url = this.transformUrl(this.channel) + this.unionFlag ? '?union=' + this.unionFlag : '';
      // }
      // window.location.href = url;
      if (this.unionFlag) {
        let url = bfdUrl + `?union=${this.unionFlag}&city=${this.city}`;
        try {
          fetchFindByUnion({
            Business: false,
          }).then(res => {
            if (res) {
              url = res.homePageUrl;
            }
            window.df_sdk_common.location.href = url;
          })
        } catch (error) {
          window.df_sdk_common.location.href = url;
        }
        
      } else {
        window.df_sdk_common.location.href = `/mall?cty=${this.city}`;
      }
    },
    // transformUrl(channel) {
    //   switch (channel) {
    //   case '3':
    //     return '/shop/birthday';
    //   case '998':
    //     return '/book';
    //   case '999':
    //     return '/shopHome/?channelId=999';
    //   case '20':
    //     return '/xmlifepc/';
    //   case '22':
    //     return '/wylife/';
    //   case '17':
    //     return '/chaoshi';
    //   default:
    //     return '/shop/home';
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.Empty {
  width: 100%;
  margin-top: 20px;
  text-align: center;
  img {
    width: 374px;
  }
  p {
    font-size: 15px;
    color: #999;
    line-height: 26px;
  }
  .empty-bottom_btn {
    margin-top: 40px;
    margin-bottom: 50px;
    span {
      display: inline-block;
      width: 136px;
      height: 40px;
      background: #3FA6FF;
      background: var(--df-primary-color, #3FA6FF);
      border-radius: 4px;
      line-height: 40px;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
      margin: 0 14px;
      box-sizing: border-box;
    }
    span.pre{
      background: transparent;
      color: #3FA6FF;
      color: var(--df-primary-color, #3FA6FF);
      border-radius:4px;
      border: solid 1px #3FA6FF;
      border: solid 1px var(--df-primary-color, #3FA6FF);
    }
  }
}
</style>
